import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { useMessage } from '@/const/messages';
export default /*#__PURE__*/ _defineComponent({
    props: {
        spread: null
    },
    setup(__props) {
        const props = __props;
        const { format, ORDERBOOK_FIELDS } = useMessage();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, _toDisplayString(_unref(format)(_unref(ORDERBOOK_FIELDS).SPREAD)) + " : " + _toDisplayString(props.spread), 1));
        };
    }
});
